var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 19,
    viewBox: "0 0 33 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5968 0.965694C32.0592 0.428102 31.1902 0.428102 30.6526 0.965694L16.5 15.1183L2.34738 0.965694C1.80979 0.428102 0.940786 0.428102 0.403194 0.965694C-0.134398 1.50329 -0.134398 2.37229 0.403194 2.90988L15.5279 18.0346C15.796 18.3027 16.148 18.4375 16.5 18.4375C16.8521 18.4375 17.204 18.3027 17.4721 18.0346L32.5968 2.90988C33.1344 2.37229 33.1344 1.50329 32.5968 0.965694Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.e25a6ef90ecdd6c73b2bbf7d069d1d70.svg";
export { ForwardRef as ReactComponent };